<!-- src/routes/privacy.svelte -->
<script>
  const last_updated = "March 28, 2024";
  import { onMount } from 'svelte';
  
  onMount(() => {
    // Add meta robots tag to prevent indexing
    const metaRobots = document.createElement('meta');
    metaRobots.name = 'robots';
    metaRobots.content = 'noindex';
    document.head.appendChild(metaRobots);
  });
</script>

<section class="privacy_page">
  <div class="content_wrapper">
    <h1>Privacy Policy</h1>
    <p class="last_updated">Last updated: {last_updated}</p>

    <div class="privacy_content">
      <p>This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.</p>

      <p>We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.</p>

      <h2>Interpretation and Definitions</h2>

      <h3>Interpretation</h3>
      <p>The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</p>

      <h3>Definitions</h3>
      <ul>
        <li><strong>"Account"</strong> means a unique account created for You to access our Service or parts of our Service.</li>
        <li><strong>"Company"</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to Down to Earth Guides.</li>
        <li><strong>"Country"</strong> refers to the United States of America.</li>
        <li><strong>"Cookies"</strong> are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.</li>
        <li><strong>"Device"</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.</li>
        <li><strong>"Personal Data"</strong> is any information that relates to an identified or identifiable individual.</li>
        <li><strong>"Service"</strong> refers to the Website.</li>
        <li><strong>"Service Provider"</strong> means any natural or legal person who processes the data on behalf of the Company.</li>
        <li><strong>"Usage Data"</strong> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself.</li>
        <li><strong>"Website"</strong> refers to Down to Earth Guides, accessible from https://downtoearthguides.com</li>
        <li><strong>"You"</strong> means the individual accessing or using the Service.</li>
      </ul>

      <h2>Collecting and Using Your Personal Data</h2>

      <h3>Types of Data Collected</h3>

      <h4>Personal Data</h4>
      <p>While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:</p>
      <ul>
        <li>Email address</li>
        <li>First name and last name</li>
        <li>Usage Data</li>
      </ul>

      <h4>Usage Data</h4>
      <p>Usage Data is collected automatically when using the Service. Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.</p>

      <h2>Use of Your Personal Data</h2>
      <p>The Company may use Personal Data for the following purposes:</p>
      <ul>
        <li>To provide and maintain our Service</li>
        <li>To notify you about changes to our Service</li>
        <li>To provide customer support</li>
        <li>To gather analysis or valuable information so that we can improve our Service</li>
      </ul>

      <h2>Contact Us</h2>
      <p>If you have any questions about this Privacy Policy, please contact us at:</p>
      <p>Email: team@downtoearthguides.com</p>
    </div>
  </div>
</section>

<style>
  .privacy_page {
    padding: 6rem 2rem;
    background: var(--color-background);
    color: var(--color-text);
  }

  .content_wrapper {
    max-width: 800px;
    margin: 0 auto;
  }

  h1 {
    font-size: 2.5rem;
    margin-bottom: 1rem;
    color: var(--color-primary);
  }

  .last_updated {
    color: var(--color-text-muted);
    margin-bottom: 2rem;
  }

  .privacy_content {
    font-size: 1.1rem;
    line-height: 1.6;
  }

  h2 {
    font-size: 1.8rem;
    margin: 2rem 0 1rem;
    color: var(--color-primary);
  }

  h3 {
    font-size: 1.4rem;
    margin: 1.5rem 0 1rem;
  }

  h4 {
    font-size: 1.2rem;
    margin: 1.2rem 0 1rem;
  }

  p {
    margin-bottom: 1rem;
  }

  ul {
    margin-bottom: 1rem;
    padding-left: 2rem;
  }

  li {
    margin-bottom: 0.5rem;
  }

  strong {
    color: var(--color-primary);
  }

  @media (max-width: 768px) {
    .privacy_page {
      padding: 4rem 1rem;
    }

    h1 {
      font-size: 2rem;
    }

    h2 {
      font-size: 1.6rem;
    }

    h3 {
      font-size: 1.3rem;
    }

    h4 {
      font-size: 1.1rem;
    }

    .privacy_content {
      font-size: 1rem;
    }
  }
</style> 